import { render, staticRenderFns } from "./ProductIntro.vue?vue&type=template&id=0d6e91ef&"
import script from "./ProductIntro.vue?vue&type=script&lang=js&"
export * from "./ProductIntro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports